// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon___1H7b_"};